import { HourFormat } from "../../../types";
export const config = {
    locale: "en-EN",
    currencyCode: "USD",
    selectionTitlesToShow: 3,
    includeLast12Months: false,
    includeLast6Months: false,
    dateTimeFormat: HourFormat.format24Hour,
    currentTimeZone: 0,
    ShowTotalProfitLossAndBets: true
};
//# sourceMappingURL=config.js.map